export const getEmailDetails = state => state.emailDetails;

export const getTaskId = state => state.taskId;

export const getLoading = state => state.loading;

export const getIsAdmin = state => state.isAdmin;

export const getError = state => state.error;
